import { Switch, Route, Redirect } from 'react-router-dom';
import Login from './Login';
import ResetPassword from './ResetPassword/ResetPassword';
import AccountRenewal from './AccountRenewal/AccountRenewal';
import NotFoundRedirect from './NotFoundRedirect/NotFoundRedirect';
import { JSX } from 'react';

const Routes = (): JSX.Element => (
  <Switch>
    <Route exact path="/password-reset/:PasswordToken">
      <ResetPassword />
    </Route>
    <Route exact path="/account-renewal/:Token">
      <AccountRenewal />
    </Route>
    <Route
      exact
      path="/"
      render={({ location }) => {
        const { hash } = location;
        return hash ? <Redirect to={hash.replace('#', '')} /> : <Login />;
      }}
    />
    <Route exact path="/login">
      <Login />
    </Route>
    <Route path="*">
      <NotFoundRedirect />
    </Route>
  </Switch>
);

export default Routes;
